import { pluralizeWithCount } from "@common/helpers/string";
import { BulkSelectionControl } from "@design-system/BulkSelectionControl/BulkSelectionControl";
import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { CommandIslandTotal } from "@design-system/CommandIsland/CommandIslandTotal";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface Props {
    total: number;
    selectedCount: number;
    isBusy: boolean;
    onClearSelection: () => void;
    onOpenBulkActions: () => void;
}

export const OrganizationTaskTemplatesFooter = ({
    total,
    selectedCount,
    isBusy,
    onClearSelection,
    onOpenBulkActions,
}: Props) => {
    const hasSelection = selectedCount > 0;

    return (
        <CommandIsland
            sticky
            className={commandIslandStyles.bulkActionsStickyFooter}
        >
            <HStack gap={8}>
                <CommandIslandTotal>
                    {pluralizeWithCount("task template", total)}
                </CommandIslandTotal>
                {hasSelection && (
                    <BulkSelectionControl
                        size="md"
                        selectedCount={selectedCount}
                        onClearSelection={onClearSelection}
                    />
                )}
            </HStack>

            {hasSelection && (
                <Tooltip content="Open bulk actions">
                    <Button
                        variant="primary"
                        size="md"
                        rightIcon={
                            <span data-slot-box="">
                                <Shortcut keys="mod+k" />
                            </span>
                        }
                        onClick={onOpenBulkActions}
                        disabled={isBusy}
                    >
                        Actions
                    </Button>
                </Tooltip>
            )}
        </CommandIsland>
    );
};
